"use client"

import { Card, CardContent } from "@/components/ui/card"
import { useLanguage } from "@/contexts/language-context"
import { useCommunicationOptions } from "@/hooks/use-communication-options"
import type { DemoOption } from "@/lib/demo-data"

interface DemoResultProps {
  option: DemoOption
}

export function DemoResult({ option }: DemoResultProps) {
  const { t } = useLanguage()
  const { getScenarioLabel, getTargetLabel, getToneLabel } = useCommunicationOptions()

  return (
    <Card className="glass dark:glass-dark shadow-xl border-0 bg-white/95 dark:bg-zinc-900/95 mt-6">
      <CardContent className="p-8">
        <div className="space-y-4">
          <div>
            <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
              {t("demo.inputContent")}
            </h4>
            <div className="bg-gray-50 dark:bg-zinc-800/50 rounded-lg p-4">
              <p className="text-sm text-gray-900 dark:text-gray-100 whitespace-pre-wrap">
                {option.inputContent}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                {t("demo.scenario")}
              </h4>
              <div className="bg-blue-50 dark:bg-indigo-700/30 rounded-lg p-3">
                <p className="text-sm text-blue-700 dark:text-indigo-300 font-medium">
                  {getScenarioLabel(option.scenario)}
                </p>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                {t("demo.target")}
              </h4>
              <div className="bg-green-50 dark:bg-green-700/30 rounded-lg p-3">
                <p className="text-sm text-green-700 dark:text-green-300 font-medium">
                  {getTargetLabel(option.target)}
                </p>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                {t("demo.tone")}
              </h4>
              <div className="bg-purple-50 dark:bg-purple-700/30 rounded-lg p-3">
                <p className="text-sm text-purple-700 dark:text-purple-300 font-medium">
                  {getToneLabel(option.tone)}
                </p>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
              {t("demo.description")}
            </h4>
            <div className="bg-gray-50 dark:bg-zinc-800/50 rounded-lg p-4">
              <p className="text-sm text-gray-900 dark:text-gray-100 whitespace-pre-wrap">
                {option.description}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}